<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'unloadAlert'
    ])
  },
  watch: {
    'unloadAlert' (nv) {
      window.document.body.onbeforeunload = nv ? (() => '') : null
    }
  }
}
</script>
